var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 234,
    viewBox: "0 0 252 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.495 37.2841C199.44 32.9209 196.708 29.1496 192.891 26.7889C189.075 24.4282 184.482 23.6687 180.11 24.6752L179.667 24.7771L179.605 24.5058C179.596 24.467 179.587 24.4282 179.578 24.3895C179.569 24.3507 179.56 24.312 179.551 24.2732C178.537 19.8672 175.815 16.0442 171.984 13.6453C168.154 11.2464 163.528 10.4681 159.124 11.4816L132.818 17.5358C121.083 20.225 110.872 27.4158 104.384 37.561C99.8521 44.5212 97.3327 52.5999 97.104 60.9042L24.7561 77.5548C22.7992 78.0031 20.9373 78.7948 19.2568 79.8934C16.2084 81.758 13.8232 84.5345 12.4388 87.8301C11.0544 91.1257 10.7408 94.7736 11.5424 98.2579L38.7447 216.453C39.7587 220.859 42.4805 224.682 46.3113 227.081C50.1421 229.48 54.7682 230.258 59.1718 229.245L234.977 188.784C239.381 187.77 243.201 185.048 245.598 181.216C247.995 177.384 248.772 172.756 247.758 168.35L220.554 50.1487C219.553 45.8076 216.893 42.0307 213.144 39.6263C209.395 37.2219 204.855 36.3812 200.495 37.2841Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 188.732C142.799 185.171 144.005 181.715 146.222 178.929C148.44 176.144 151.536 174.194 155.006 173.398L227.83 156.638L231.392 172.116L143.492 192.346L143.456 192.191C143.312 191.561 143.128 190.941 142.907 190.335C142.87 190.055 142.847 189.781 142.839 189.51C142.803 189.251 142.797 188.995 142.8 188.732Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.89 190.338C143.112 190.945 143.295 191.565 143.439 192.194L143.475 192.35L55.5695 212.581L52.0073 197.103L124.593 180.398C128.329 179.538 132.251 180.073 135.621 181.904C138.991 183.735 141.576 186.734 142.89 190.338Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3662 94.3801L52.0076 197.103L55.5698 212.581L143.475 192.35L231.375 172.12L227.813 156.642L204.172 53.919L188.088 57.6206",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 191.414L142.823 189.515L139.685 175.881L119.761 89.311L114.912 68.2403L114.581 66.8005",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.878 44.9834L184.155 41.2373L208.445 146.779L158.014 158.386C152.423 159.672 147.572 163.129 144.529 167.994C141.486 172.86 140.5 178.736 141.787 184.33L143.41 191.38",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.943 135.69L161.637 141.744C146.39 145.253 136.323 160.59 139.835 175.846L140.495 178.715",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.169 28.0435L136.863 34.0977C121.615 37.6069 111.55 52.9497 115.061 68.2059L115.72 71.0688",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.222 28.2764L167.108 45.1606L187.943 135.69",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.586 54.7588L132.526 55.4632C127.366 56.6522 122.89 59.843 120.082 64.3338C117.274 68.8247 116.365 74.2479 117.553 79.4107L118.794 84.8044",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.07 65.552L135.01 66.2564C129.85 67.4438 125.374 70.6334 122.566 75.1234C119.757 79.6134 118.847 85.036 120.035 90.1984L121.277 95.5921",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.542 111.049L145.481 111.753C140.321 112.942 135.845 116.133 133.037 120.624C130.23 125.115 129.32 130.538 130.508 135.701L131.748 141.089",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.024 121.836L147.963 122.541C142.806 123.732 138.334 126.924 135.528 131.414C132.722 135.904 131.814 141.325 133.002 146.486L134.243 151.879",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.444 75.8685L137.384 76.5729C132.226 77.7646 127.752 80.957 124.947 85.4482C122.141 89.9395 121.234 95.3619 122.423 100.523L123.663 105.912",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.478 196.995L124.593 180.398C128.33 179.538 132.252 180.073 135.621 181.904C138.991 183.735 141.576 186.735 142.89 190.339C143.112 190.945 143.295 191.565 143.44 192.195",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.11 156.804L155.006 173.398C151.536 174.194 148.439 176.144 146.222 178.929C144.005 181.715 142.798 185.171 142.8 188.732C142.796 188.996 142.803 189.251 142.822 189.514C142.842 189.778 142.861 190.089 142.89 190.339C142.951 190.982 143.055 191.62 143.201 192.249",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7993 94.1111L100.915 77.5139C102.926 77.0503 105.009 76.9876 107.045 77.3296C109.081 77.6715 111.029 78.4114 112.779 79.5069C114.53 80.6024 116.047 82.032 117.245 83.7142C118.443 85.3964 119.298 87.2981 119.761 89.3108",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.997 115.069L115.947 149.612L57.1919 163.135L54.6582 152.126L43.6621 104.347L102.417 90.8249L107.997 115.069Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3071 174.1L104.94 163.597",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8129 152.09C54.8129 152.09 54.8141 129.711 65.6133 128.118C73.5721 126.945 72.9203 137.077 80.2748 134.621C89.7505 131.455 80.6392 115.668 90.551 109.206C99.9271 103.101 107.714 115.134 107.714 115.134",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.af0493028ef16cbc0a0fca3f7bc5c81e.svg";
export { ForwardRef as ReactComponent };